import React from 'react';
import { Typography, Box, Button, Modal, } from '@mui/material';
import { useTheme } from '../../contexts/ThemeContext';

const QuestionModal = (props) => {
  const { theme } = useTheme();

  const styles = {
    modal: {
      position: 'absolute',
      top: '25%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '20vw',
      bgcolor: theme.background.primary,
      borderRadius: 2,
      border: `4px solid ${theme.color.primary}`,
      boxShadow: 24,
      p: 4,
      outline: 'none',
    },
    button: {
      textTransform: 'none',
      fontFamily: theme.fontFamily,
      color: theme.text.negative,
      borderRadius: '20px',
      border: `1px solid ${theme.border.light}`
    }
  };

  return (
    <Modal open={props.open} onClose={() => props.setOpen(false)}>
      <Box sx={styles.modal}>
        <Typography variant="h6" component="h2" gutterBottom style={{ fontFamily: theme.fontFamily, textAlign: 'center', color: theme.text.primary }}>
          {props.message}
        </Typography>

        {/* Cancel button */}
        <Box sx={{ display: 'flex', justifyContent: 'space-around', mt: 3 }}>
          <Button variant="contained" sx={{ ...styles.button, backgroundColor: theme.accent.success, }} onClick={props.confirm} >
            Yes
          </Button>
          <Button variant="contained" sx={{ ...styles.button, backgroundColor: theme.accent.error, }} onClick={props.cancel} >
            No
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default QuestionModal;